import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the total contingencies view.
 * @extends JetView
 */
export default class totalContingenciesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 0,
            autoheight: true,
            id: 'a1',
            rows: [
                {
                    margin: 0,
                    css: 'on-row',
                    responsive: 'a1',
                    // Determine visibility based on permissions
                    hidden:
                        !devConfig.getPermAction('configurationSecurityChangesEstadoContingenciaSwitch', 'Switch') &&
                        !devConfig.getPermAction('configurationSecurityChangesContingenciaDeportivasSwitch', 'Switch'),
                    cols: [
                        {
                            view: 'form',
                            id: 'Contingency',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesEstadoContingenciaSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesEstadoContingenciaSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Total'), // Label for total contingency
                                },
                                {
                                    id: 'StateContingencySwith',
                                    view: 'switch', // Switch for total contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencySwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"Contingency","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencySwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"Contingency","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencySwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form',
                            id: 'ContingencyDeportivas',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaDeportivasSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaDeportivasSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Deportivas'), // Label for sports contingency
                                },
                                {
                                    id: 'StateContingencyDeportivasSwith',
                                    view: 'switch', // Switch for sports contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencySports","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyDeportivasSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencySports","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyDeportivasSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0,
                    css: 'on-row',
                    responsive: 'a1',
                    // Determine visibility based on permissions
                    hidden:
                        !devConfig.getPermAction(
                            'configurationSecurityChangesContingenciaWithdrawalSwitch',
                            'Switch',
                        ) &&
                        !devConfig.getPermAction('configurationSecurityChangesContingenciaDepositSwitch', 'Switch'),
                    cols: [
                        {
                            view: 'form',
                            id: 'ContingencyWithdrawal',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaWithdrawalSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaWithdrawalSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Retiro'), // Label for withdrawal contingency
                                },
                                {
                                    id: 'StateContingencyWithdrawalSwith',
                                    view: 'switch', // Switch for withdrawal contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyWithdrawalSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyWithdrawal","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyWithdrawalSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyWithdrawal","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyWithdrawalSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form',
                            id: 'ContingencyDeposit',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaDepositSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaDepositSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Depósito'), // Label for deposit contingency
                                },
                                {
                                    id: 'StateContingencyDepositSwith',
                                    view: 'switch', // Switch for deposit contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyDepositwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyDeposit","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyDepositSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyDeposit","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyDepositSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0,
                    css: 'on-row',
                    responsive: 'a1',
                    // Determine visibility based on permissions
                    hidden: !devConfig.getPermAction('configurationSecurityChangesContingenciaCasinoSwitch', 'Switch'),
                    cols: [
                        {
                            view: 'form',
                            id: 'ContingencyCasino',
                            // Determine visibility based on permissions
                            hidden:
                                !devConfig.getPermAction(
                                    'configurationSecurityChangesContingenciaCasinoSwitch',
                                    'Switch',
                                ) &&
                                !devConfig.getPermAction(
                                    'configurationSecurityChangesContingenciaCasinoenVivoSwitch',
                                    'Switch',
                                ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaCasinoSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Casino'), // Label for casino contingency
                                },
                                {
                                    id: 'StateContingencyCasinoSwith',
                                    view: 'switch', // Switch for casino contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyCasinoSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyCasino","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyCasinoSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyCasino","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyCasinoSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form',
                            id: 'ContingencyCasinoVivo',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaCasinoenVivoSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaCasinoenVivoSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Casino en Vivo'), // Label for live casino contingency
                                },
                                {
                                    id: 'StateContingencyCasinoVivoSwith',
                                    view: 'switch', // Switch for live casino contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyCasinoVivo","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyCasinoVivo","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0,
                    css: 'on-row',
                    responsive: 'a1',
                    // Determine visibility based on permissions
                    hidden:
                        !devConfig.getPermAction('configurationSecurityChangesContingenciaVirtualesSwitch', 'Switch') &&
                        !devConfig.getPermAction('configurationSecurityChangesContingenciaPokerSwitch', 'Switch'),
                    cols: [
                        {
                            view: 'form',
                            id: 'ContingencyVirtuales',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaVirtualesSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaVirtualesSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Virtuales'), // Label for virtual contingency
                                },
                                {
                                    id: 'StateContingencyVirtualesSwith',
                                    view: 'switch', // Switch for virtual contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyVirtuales","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message('¡Error!');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            webix.message('Cambios Realizados');
                                                            $$('StateContingencyVirtualesSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyVirtuales","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyVirtualesSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form',
                            id: 'ContingencyPoker',
                            // Determine visibility based on permissions
                            hidden: !devConfig.getPermAction(
                                'configurationSecurityChangesContingenciaPokerSwitch',
                                'Switch',
                            ),
                            css: 'secutity prm-configurationSecurityChangesContingenciaPokerSwitch',
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Contingencia Poker'), // Label for poker contingency
                                },
                                {
                                    id: 'StateContingencyPokerSwith',
                                    view: 'switch', // Switch for poker contingency state
                                    labelWidth: 55,
                                    css: 'widthSwith',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                    click: () => {
                                        // Handle switch click event
                                        if ($$('StateContingencyPokerSwith').getValue() == 1) {
                                            // If switch is activated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyPoker","IsActivate":"A"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyPokerSwith').setValue(1); // Set switch value to 1
                                                        },
                                                    },
                                                );
                                        } else {
                                            // If switch is deactivated
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/UpdateTotalContigency',
                                                    '{"Action":"ContingencyPoker","IsActivate":"I"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handling
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error.'),
                                                            });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            text = JSON.parse(text);
                                                            if (!text.HasError) {
                                                                // Success message
                                                                webix.message(_('Cambios Realizados'));
                                                            }
                                                            $$('StateContingencyPokerSwith').setValue(0); // Set switch value to 0
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'secutity',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing forms and switches
                },
            ],
        };
        return {
            height: screen.width > 500 && screen.height > 500 ? 0 : 960, // Set height based on screen size
            rows: [upper_section], // Main layout structure
        };
    }

    /**
     * Initializes the view and fetches initial data.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        // Adding custom styles for background colors
        webix.html.addStyle('.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }');
        webix.html.addStyle('.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }');
        // Fetching initial contingency data
        webix.ajax().get(devConfig.geturlApi() + 'Configuration/TotalContigency', '', {
            error: function (text, data, XmlHttpRequest) {
                // Error handling
                webix.message({
                    title: _('¡Error!'),
                    type: 'alert-error',
                    text: _('Ocurrio un error.'),
                });
            },
            success: function (text, data, XmlHttpRequest) {
                text = JSON.parse(text); // Parse the response
                // Set switch values based on fetched data
                if (text[0].IsActivateContingency == 'A') {
                    $$('StateContingencySwith').setValue(1);
                } else {
                    $$('StateContingencySwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDeportivas == 'A') {
                    $$('StateContingencyDeportivasSwith').setValue(1);
                } else {
                    $$('StateContingencyDeportivasSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasino == 'A') {
                    $$('StateContingencyCasinoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                    $$('StateContingencyCasinoVivoSwith').setValue(1);
                } else {
                    $$('StateContingencyCasinoVivoSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyVirtuales == 'A') {
                    $$('StateContingencyVirtualesSwith').setValue(1);
                } else {
                    $$('StateContingencyVirtualesSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyPoker == 'A') {
                    $$('StateContingencyPokerSwith').setValue(1);
                } else {
                    $$('StateContingencyPokerSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyWithdrawal == 'A') {
                    $$('StateContingencyWithdrawalSwith').setValue(1);
                } else {
                    $$('StateContingencyWithdrawalSwith').setValue(0);
                }
                if (text[0].IsActivateContingencyDeposit == 'A') {
                    $$('StateContingencyDepositSwith').setValue(1);
                } else {
                    $$('StateContingencyDepositSwith').setValue(0);
                }
            },
        });
    }
}

// FILE DOCUMENTED
